<template>
  <div class="zpm">
    <h2>我是zpm页面</h2>
  </div>
</template>

<script>
export default {
    name: 'zpm'
}
</script>

<style lang="scss">
.zpm{
    color:red
}
</style>